export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9237.f319d847.jpg";